import { useIntl } from 'react-intl';
import { IconLock } from '@rossum/ui/icons/tabler';
import { Alert, SvgIcon } from '@rossum/ui/material';

export const EngineSchemaLockedMessage = () => {
  const intl = useIntl();

  return (
    <Alert
      variant="filled"
      severity="info"
      icon={
        <SvgIcon fontSize="medium">
          <IconLock />
        </SvgIcon>
      }
      sx={{
        width: '100%',
        fontWeight: 'normal',
      }}
    >
      {intl.formatMessage({
        id: `components.engineSchemaLockedMessage.locked`,
      })}
    </Alert>
  );
};
